<div class="new-bingo-tile" *ngIf="bingoItem.displayRoom && !bingoItem.tournament_enabled" [ngClass]="renderRoomClass()">
    <div class="tile">
        <!-- Slider Component -->
        <div class="bg-slider-container" [ngClass]="isSlideOpen ? 'open-slide' : ''" [id]="'bg-slider-' + index">
            <bg-tile-slider
                *ngIf="isSlideOpen"
                [RoomId]="bingoItem.id"
                [roomName]="bingoItem.name"
                [bingoType]="bingoItem.bingo_type"
                [isFavourite]="bingoItem.isFavourite"
                [isTitle]="isTitle"
                [favIcon]="roomIconslist.columns.favIcon"
                [favMarkedIcon]="roomIconslist.columns.favMarkedIcon"
                [isFavEnabled]="IsFavouriteEnabled"
                [feature]="selectedFeatureInfo"
                (closeSlider)="onCloseSlider()">
            </bg-tile-slider>
        </div>

        <!-- Locked Room -->
        <div
            class="room-locked"
            *ngIf="bingoItem.isRoomLocked || bingoItem.lockRoomInLogoutStage || (bingoItem.displayPrivateRoom && bingoItem.privateRoom)">
            <span>{{ roomLockedText }}</span>
            <i class="theme-locked-i mt-2"></i>
            <div class="moreinfo-card" (click)="roomLockedMoreInfo(bingoItem)">
                <bg-custombutton [variant]="'outline'" [kind]="'tertiary'" [inverse]="true" [customClass]="'moreinf'" [button_text]="moreInfoText"
                    >{{ moreInfoText }}
                </bg-custombutton>
            </div>
        </div>

        <!-- Ribbon Elements -->
        <div
            class="ribbon"
            *ngIf="bingoItem.optimoveLabel && bingoItem.enableStickerForRoom"
            [ngStyle]="{ background: roomIconslist?.attributes?.roomTopRibbonBgClr, color: roomIconslist?.attributes?.roomTopRibbonClr }">
            <i class="theme-bingo-star"></i>{{ bingoItem.optimoveLabel }}
        </div>
        <div
            class="ribbon"
            *ngIf="bingoItem.isPreferredRoom && !bingoItem.optimoveLabel"
            [ngStyle]="{ background: roomIconslist?.attributes?.roomTopRibbonBgClr, color: roomIconslist?.attributes?.roomTopRibbonClr }">
            <i class="theme-bingo-star"></i>{{ roomIconslist.columns.preferredBingoRoom }}
        </div>

        <!-- Card Content -->
        <div class="tile-top-section">
            <img src="{{ bingoItem.roomImage ? bingoItem.roomImage : thumbImageSrc }}" class="tile-image" />
            <div class="friends-copyRight" *ngIf="isFriendsRoom">
                <span [innerHTML]="friendsBingoCopyRights"></span>
            </div>
            <div
                class="jackpot"
                *ngIf="bingoItem.pjps_in_player_currency && bingoItem.pjps_in_player_currency.length > 0 && !bingoItem.isCombinedRoom"
                [ngStyle]="{ background: roomIconslist?.attributes?.jackpotBgColor, color: roomIconslist?.attributes?.jackpotTextColor }"
                [ngClass]="bingoItem.hover ? 'hover' : ''">
                <span class="jp-tooltip">{{ roomnavlist.columns.jackpot }}</span>
                <span class="jp-container">
                    <img src="{{ getPrizeIconPath('jackpot') }}" class="jackpot-icon" alt="trophy" />
                </span>

                <div class="jackpot-values" *ngIf="!bingoItem.isCombinedRoom">
                    <span
                        class="schedule-item__value"
                        *ngFor="let pjp of bingoItem.pjps_in_player_currency"
                        [ngClass]="bingoItem.pjps_in_player_currency.length > 1 ? 'pjp-fadeout' : ''"
                        >{{ pjp.value.Cash | vnCurrency }}
                    </span>
                </div>
            </div>
            <div class="timerclass">
                <span class="feature-icons">
                    @for (item of bingoItem.features; track $index) {
                        @if (!noFeatureIcons.includes(item)) {
                            <span class="room-feature" (click)="toggleCardSlider(item)">
                                <bg-feature-icon [feature]="item" [isNewBingoTile]="true"></bg-feature-icon>
                                <span class="feature-name">{{ getFeatureName(item) || item.replaceAll('_', ' ') }}</span>
                            </span>
                        }

                        @if (item == 'country_miles') {
                            <span class="room-feature" (click)="toggleCardSlider(item)">
                                <div class="bingo-feature-icon-new feature-country-miles-trophy">
                                    <img class="feature-img" alt="" [src]="countryMilesIcon" />
                                </div>
                                <span class="feature-name">{{ getFeatureName(item) || item.replaceAll('_', ' ') }}</span>
                            </span>
                        }
                    }
                </span>

                <span
                    bgTimer
                    class="timer"
                    [timerColor]="roomIconslist?.attributes?.timerConfigTextColorTwo"
                    [timerBgColor]="roomIconslist?.attributes?.timerConfigBgColorTwo"
                    [ngStyle]="{ background: roomIconslist?.attributes?.timerConfigBgColor, color: roomIconslist?.attributes?.timerConfigTextColor }"
                    [ngClass]="{ 'insurance-btn': bingoItem.insurance && bingoItem.status?.state_end_time != null }">
                    <i class="theme-clock-solid" *ngIf="!bingoItem.sit_n_go_enabled"></i>
                    <div
                        class="insurance-timerclass"
                        *ngIf="(bingoItem.insurance && bingoItem.status?.state_end_time != null) || bingoItem.sit_n_go_enabled">
                        <div>{{ playingSoonText }}</div>
                    </div>
                    <bg-schedule-timer
                        *ngIf="(!bingoItem.insurance || bingoItem.status?.state_end_time == null) && !bingoItem.sit_n_go_enabled"
                        [timerinput]="bingoItem.status.state_end_time"
                        (timerChange)="onTimeNotification($event)">
                    </bg-schedule-timer>
                </span>
            </div>
        </div>
        <div class="tile-progress-bar">
            <div class="tile-progress-bar__content" *ngIf="IsProgressBar && !bingoItem.sit_n_go_enabled">
                <div class="tile-progress-bar__bar" [@barAnimation]="getAnimationState()"></div>
            </div>
        </div>
        <div
            class="tile-bottom-section"
            [ngClass]="{ 'superlink-rooms': bingoItem.isSuperLink, 'superlink-image': bingoItem.bgImage, 'sng': bingoItem.sit_n_go_enabled }">
            <img src="{{ bingoItem.bgImage }}" class="superlink-bg" *ngIf="bingoItem.bgImage" />

            <div class="name-section" (click)="toggleCardSliderGameName(bingoItem.bingo_type)">
                <span class="ball-type-container">
                    <img src="{{ getBallTypeIconPath() }}" class="ball-type-icon" />
                    <!-- 
                        <span class="info-icon-container" [ngClass]="'bb-type-' + bingoItem.bingo_type">
                            <span class="theme-info info-icon"></span>
                        </span>
                    -->
                </span>
                <span class="game-name" [ngStyle]="{ color: isFabGrabRoom ? roomIconslist?.attributes?.fabgrabTextClr : '' }"
                    >{{ bingoItem.name | titlecase }}
                    <div
                        class="single-entry-count"
                        *ngIf="bingoItem.isCombinedRoom"
                        [ngStyle]="{ color: roomIconslist?.attributes?.singleEntryPointClr }">
                        <span>{{ bingoItem.gameCount }} {{ combinedRoomsCount }}</span>
                    </div>
                </span>
                <span *ngFor="let item of bingoItem.features">
                    <span *ngIf="item == 'linked_game'">
                        <i [ngClass]="roomIconslist.columns.linkedIcon"></i>
                    </span>
                </span>

                <span class="theme-info info-icon"></span>
            </div>
            <ul class="pills-section" [ngClass]="{ 'combinedroom-details': bingoItem.isCombinedRoom && enableIconReplacement }">
                <li *ngIf="!bingoItem.sit_n_go_enabled" [ngStyle]="{ color: isFabGrabRoom ? roomIconslist?.attributes?.fabgrabTextClr : '' }">
                    <span class="icon-text">{{ roomnavlist.columns.players }}</span>
                    <span class="cmn-icon-container">
                        <i class="cmn-icon" [ngClass]="roomIconslist.columns.cappedPlayerIcon"></i>
                    </span>
                    <span class="text-ellipsis">{{ bingoItem.number_of_players }}</span>
                </li>

                <li *ngIf="!bingoItem.sit_n_go_enabled" [ngStyle]="{ color: isFabGrabRoom ? roomIconslist?.attributes?.fabgrabTextClr : '' }">
                    <span class="icon-text">{{ roomnavlist.columns.gamePrize }}</span>
                    <span class="cmn-icon-container" *ngIf="!(bingoItem.isCombinedRoom || isPhysicalPrize || isBonusPrize)">
                        <!-- <i class="cmn-icon" [ngClass]="roomIconslist.columns.jackpotIcon"> </i> -->
                        <img src="{{ getPrizeIconPath('total_prize') }}" class="cmn-icon total-prize-icon" />
                    </span>
                    <span class="text-ellipsis" *ngIf="!isPhysicalPrize && !isBonusPrize && !bingoItem.isCombinedRoom">{{
                        bingoItem.pot_in_player_currency.Cash | bgFloatTruncate: bingoItem.number_of_players : dynaconParams
                    }}</span>
                    <span class="text-ellipsis" *ngIf="isPhysicalPrize && !isBonusPrize && !bingoItem.isCombinedRoom">{{ physicalPrizeText }}</span>
                    <span class="text-ellipsis" *ngIf="isBonusPrize && !bingoItem.isCombinedRoom">{{ bonusPrizeText }}</span>
                    <bg-feature-icon
                        class="combined-room-icon"
                        *ngIf="bingoItem.isCombinedRoom && bingoItem.combinedRoomHasPrize && !enableIconReplacement"
                        [feature]="bingoItem.combinedRoomFeature"
                        [isNewBingoTile]="true">
                    </bg-feature-icon>
                    <span class="text-ellipsis" *ngIf="bingoItem.isCombinedRoom && bingoItem.combinedRoomHasPrize && enableIconReplacement">
                        {{ combinedPrizeText }}</span
                    >
                </li>

                <li
                    *ngIf="!bingoItem.isCombinedRoom || (bingoItem.isCombinedRoom && bingoItem.combinedRoomHasPrice)"
                    [ngStyle]="{ color: isFabGrabRoom ? roomIconslist?.attributes?.fabgrabTextClr : '' }">
                    <span class="icon-text">{{ roomnavlist.columns.ticketPrice }}</span>
                    <span class="cmn-icon-container">
                        <i class="cmn-icon" *ngIf="!bingoItem.isCombinedRoom" [ngClass]="roomIconslist.columns.cardIcon"> </i>
                    </span>
                    <span class="text-ellipsis" *ngIf="!bingoItem.isCombinedRoom">
                        {{ bingoItem.card_price_in_player_currency.Cash | vnCurrency }}
                    </span>
                    <bg-feature-icon
                        class="combined-room-icon"
                        *ngIf="bingoItem.isCombinedRoom && bingoItem.combinedRoomHasPrice && !enableIconReplacement"
                        [feature]="bingoItem.combinedRoomFeature"
                        [isNewBingoTile]="true">
                    </bg-feature-icon>
                    <span
                        class="text-ellipsis"
                        *ngIf="bingoItem.isCombinedRoom && bingoItem.combinedRoomHasPrice && enableIconReplacement"
                        [ngClass]="{ sng: bingoItem.sit_n_go_enabled }"
                        >{{ combinedPriceText }}</span
                    >
                </li>
            </ul>
            <div class="buttons-container">
                <div class="btn-div btns-sub-div">
                    <bg-custombutton
                        *ngIf="isPreBuy"
                        [variant]="'outline'"
                        [kind]="'tertiary'"
                        [size]="'medium'"
                        [customClass]="'pre-buy-button'"
                        [disabled]="
                            !bingoItem.prebuy_enabled ||
                            bingoItem.isRoomLocked ||
                            disablePreBuy ||
                            bingoItem.insurance ||
                            (bingoItem.isSuperLink && !bingoItem.prebuy_enabled)
                        "
                        [button_text]="roomnavlist.columns.roomTabPreBuyButtonText"
                        (click)="preBuy(bingoItem.id)"
                        >{{ roomnavlist.columns.roomTabPreBuyButtonText }}
                    </bg-custombutton>

                    <bg-custombutton
                        [variant]="'filled'"
                        [kind]="'primary'"
                        [size]="'medium'"
                        [customClass]="'play-now-button'"
                        [disabled]="bingoItem.isRoomLocked || isPlayButtonDisabled || (isGrayedOut && isGreyoutPlayNow)"
                        [button_text]="roomnavlist.columns.playNowBtnMobileText"
                        [ngClass]="!isPreBuy ? 'full-width' : ''"
                        (clickEmit)="gameLaunch(bingoItem, $event)"
                        >{{ roomnavlist.columns.playNowBtnMobileText }}
                    </bg-custombutton>
                </div>
            </div>
        </div>
    </div>
</div>
